import React from "react";
import PropTypes from "prop-types";

import { styled } from "@mui/material/styles";

import Link from "@mui/material/Link";

const PREFIX = "PoweredBy";

const classes = {
  root: `${PREFIX}-root`,
  poweredBy: `${PREFIX}-poweredBy`,
  poweredByLink: `${PREFIX}-poweredByLink`,
  poweredByImage: `${PREFIX}-poweredByImage`,
  poweredByImageLogo: `${PREFIX}-poweredByImageLogo`,
};

const Root = styled("div")(() => ({
  [`& .${classes.poweredBy}`]: {
    textAlign: "center",
  },
  [`&.${classes.root}`]: {},

  [`& .${classes.poweredBy}`]: {
    textAlign: "center",
  },

  [`& .${classes.poweredByImage}`]: {
    position: "absolute",
    opacity: 0.1,
    transition: "all .15s ease-in-out",
    width: 210,
  },
  [`& .${classes.poweredByImageLogo}`]: {
    width: 210,
  },

  [`& .${classes.poweredByLink}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "&:hover": {
      [`& .${classes.poweredByImage}`]: {
        opacity: 1,
      },
    },
  },
}));

export default function PoweredBy({ arena }) {
  return (
    <Root className={classes.root}>
      <Link
        target="_blank"
        underline="none"
        className={classes.poweredByLink}
        href={`https://empiresport.tv/?utm_source=${arena.title}&utm_campaign=footer_link`}
      >
        <img
          className={classes.poweredByImageLogo}
          src="https://static.cdn.videosport.ru/uploads/powered-1.svg"
        />
        <img
          className={classes.poweredByImage}
          src="https://static.cdn.videosport.ru/uploads/powered.svg"
        />
      </Link>
    </Root>
  );
}

PoweredBy.propTypes = {
  arena: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
};
